import { defineStore } from 'pinia'
import { ref } from 'vue'

export const useUserStore = defineStore('user', () => {
  const token = ref(localStorage.getItem('token') || '')

  // 尝试从 localStorage 恢复用户信息
  let storedUserInfo = null
  try {
    const raw = localStorage.getItem('userInfo')
    if (raw) storedUserInfo = JSON.parse(raw)
  } catch { /* ignore parse error */ }

  const userInfo = ref(storedUserInfo)

  const setToken = (newToken) => {
    token.value = newToken
    localStorage.setItem('token', newToken)
  }

  const setUserInfo = (info) => {
    userInfo.value = info
    if (info) {
      localStorage.setItem('userInfo', JSON.stringify(info))
    } else {
      localStorage.removeItem('userInfo')
    }
  }

  const clearAuth = () => {
    token.value = ''
    userInfo.value = null
    localStorage.removeItem('token')
    localStorage.removeItem('userInfo')
  }

  const isLoggedIn = () => !!token.value

  // 仅 admin 可访问财务管理、系统设置
  const isAdmin = () => {
    return userInfo.value?.role === 'admin'
  }

  return {
    token,
    userInfo,
    setToken,
    setUserInfo,
    clearAuth,
    isLoggedIn,
    isAdmin,
  }
})
